import fetchHandler, { fetchHandlerForm } from './Handler';

// import { Category } from '../../types/cards';

export const createQuotation = async (body: any): Promise<any> => {
	console.log(body, '------------->');
	try {
		const response = await fetchHandler({
			method: 'POST',
			endpoint: 'admin/quotation',
			data: body,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};

export const getAllQuotation = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admin/quotation', // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};

export const deleteQuotation = async (data: any): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'DELETE',
			endpoint: `admin/quotation/${data}`,
		});
		// if (response) {
		// return await getAllProducts();
		// }
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const SendQuotation = async (data: any): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'POST',
			endpoint: `admin/quotation/send/${data}`,
			// data,
		});
		// if (response) {
		// return await getAllProducts();
		// }
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

// =======================================================
export const updateQuotation = async (body: any, id: any): Promise<any> => {
	// console.log(data, 'data>>>>>>>>>>>');
	try {
		const response = await fetchHandler({
			method: 'PATCH',
			endpoint: `admin/quotation/${id}`,
			data: body,
		});
		return response;
	} catch (error) {
		// console.error('Error fetching chatbots:', error);
		// throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const getQuotationById = async (id: string | undefined): Promise<any> => {
	// console.log(data, 'data>>>>>>>>>>>');
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `admin/quotation/${id}`,
			// data: body,
		});
		return response;
	} catch (error) {
		// console.error('Error fetching chatbots:', error);
		// throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const updateQuotationStatus = async (body: any, id: string): Promise<any> => {
	// console.log(data, 'data>>>>>>>>>>>');
	try {
		const response = await fetchHandler({
			method: 'PATCH',
			endpoint: `admin/quotation/${id}/status`,
			data: body,
		});
		return response;
	} catch (error) {
		// console.error('Error fetching chatbots:', error);
		// throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const HandlePDFCreate = async (body: any, id: string): Promise<any> => {
	// console.log(data, 'data>>>>>>>>>>>');
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `admin/quotation/${body}pdf/${id}`,
			// data: body,
		});
		return response;
	} catch (error) {
		// console.error('Error fetching chatbots:', error);
		// throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const GetSingleQuotation = async (id: any): Promise<any> => {
	// console.log(data, 'data>>>>>>>>>>>');
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `admin/quotation/${id}`,
			// data: body,
		});
		return response;
	} catch (error) {
		// console.error('Error fetching chatbots:', error);
		// throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const CategoryQuotationprams = async (id: string): Promise<any> => {
	// console.log(data, 'data>>>>>>>>>>>');
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `admin/catgeory/tags/categories/?tag=${id}`,
			// data: body,
		});
		return response;
	} catch (error) {
		// console.error('Error fetching chatbots:', error);
		// throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const MennuTypeQuotation = async (id: string): Promise<any> => {
	// console.log(data, 'data>>>>>>>>>>>');
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `admin/eventtype/${id}/menutypes`,
			// data: body,
		});
		return response;
	} catch (error) {
		// console.error('Error fetching chatbots:', error);
		// throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const SubCategoryQuotationprams = async (id: string): Promise<any> => {
	// console.log(data, 'data>>>>>>>>>>>');
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `admin/subcatgeory/category/${id}`,
			// data: body,
		});
		return response;
	} catch (error) {
		// console.error('Error fetching chatbots:', error);
		// throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

export const updateCategoryStatus = async (data: any, id: string): Promise<any> => {
	try {
		const response = await fetchHandlerForm({
			method: 'PATCH',
			endpoint: `category/${id}`,
			body: data,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

export const getSingleCategory = async (id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `category/${id}`,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const deleteContacts = async (id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `category/${id}`,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
